import React, { useState } from "react";
import { Card, ListGroup } from "react-bootstrap";
import imgSitu from '../../assets/images/logositu.png';
import imgConsorcio from '../../assets/images/consorcio.jpeg';
import imgMunicipio from '../../assets/images/municipio-204.png';
import imgClipp from '../../assets/images/icon-clip.png';
import imgLogos from '../../assets/images/logos.png';
import ModalCard from "../ModalCard/ModalCard";
import CardService from '../../services/CardService';

const titleHeader = {
    fontSize: '14px',
    color: 'blue'
}
const titleFooter = {
    fontSize: '12px',
    color: 'blue'
}
const headerCard = {
    height: '30px',
    textAlign: 'center',
    backgroundColor: '#D6D6D6',
}
const bodyCard = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
}
const footerCard = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
}
const fondoFooter = {
    backgroundColor: '#D6D6D6',
}
const footerChildrenCard1 = {
    flexGrow: '1',
    padding: '0px 2%'
}
const footerChildrenCard3 = {
    flexGrow: '3',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
}
const styleImgSitu = {
    width: '80%',
    marginTop: '10px'
}
const styleImgConsorcio = {
    width: '70%',
    marginTop: '0px'
}
const styleImgMunicipio = {
    width: '30px',
    marginTop: '0px',
    marginLeft: '-20px'
}
const styleImgClipp = {
    width: '40px',
    marginTop: '5px',
    paddingLeft: '2px'
}
const styleLogos = {
    width: '80px',
    marginTop: '5px',
    paddingLeft: '2px'
}
const CardBannerCliente = ({ data }) => {
    const [modalShow, setModalShow] = useState(false);
    const [dataCard, setDataCard] = useState({});

    const getDataTransactionCard = (dataTarjeta) => {

        CardService.findModal(dataTarjeta)
            .then((response) => {

                if (Object.keys(response).length !== 0) {
                    setDataCard(response)
                    setModalShow(true)
                }
            })
            .catch((error) => {
                this.warningAlert('Ha ocurrido un error Traer informacion', error.m);
                setModalShow(false)
            });
    }

    return (
        <>
            <Card style={{cursor: 'pointer'}} onClick={() => getDataTransactionCard(data.numeroTarjeta)}>
                <ListGroup variant="flush">
                    <ListGroup.Item style={headerCard}>
                        <Card.Title style={titleHeader}>{data.tarifa}</Card.Title>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <div style={bodyCard}>
                            <div><h6>Cliente:</h6></div><div><h6 style={{textAlign: 'right'}}>{data.nombre} {data.apellido}</h6></div>
                        </div>
                        <div style={bodyCard}>
                            <div><h6>#Tarjeta:</h6></div><div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden'}}><h6>{data.numeroTarjeta}</h6></div>
                        </div>
                        <div style={bodyCard}>
                            <div><h6>Estado:</h6></div><div><h6>{data.estadoTarjeta}</h6></div>
                        </div>
                        <div style={bodyCard}>
                            <div><h6>Saldo:</h6></div><div><h6>{data.saldo}</h6></div>
                        </div>
                    </ListGroup.Item>
                    <ListGroup.Item style={fondoFooter}>
                        <div style={footerCard}>
                            <div style={footerChildrenCard1}>
                                <div style={titleFooter}><a href="https://situloja.com/" target="_blank">www.situloja.com</a></div>
                                <div style={titleFooter}>072571769</div>
                            </div>
                            <div style={footerChildrenCard3}>
                                {/* <div><img src={imgLogos} alt="" style={styleLogos}/></div> */}
                                <div>
                                    <img src={imgSitu} alt="" style={styleImgSitu} />
                                </div>
                                <div>
                                    <img src={imgConsorcio} alt="" style={styleImgConsorcio} />
                                </div>
                                <div>
                                    <img src={imgMunicipio} alt="" style={styleImgMunicipio} />
                                </div>
                                <div>
                                    <img src={imgClipp} alt="" style={styleImgClipp} />
                                </div>
                            </div>
                        </div>
                    </ListGroup.Item>
                </ListGroup>
            </Card>

            {Object.keys(dataCard).length !== 0 ?
                <ModalCard show={modalShow} onHide={() => setModalShow(false)} data={dataCard.data} nrotarjeta={data.numeroTarjeta}/>
                : null
            }
        </>
    )
}
export default CardBannerCliente